
export class AchDebitCreateDto {
  public sourceLinkedPlaidBankAccountId: string;
  public clientBankAccountId: number;
  public destinationUnitBankAccountId: number;
  public amount: number;
  public idempotencyKey: string;
  public holdingId: number;
  public paymentToken: string;
  public description: string;
  public addenda: string;
  public externalAccountId: string;
  public accessTokenId: string;
  public beneficiaryName: string;
}
